module.exports = __webpack_public_path__ + "img/geoclock_logo.73172d31.png";